import { useReveal, Image } from '@ccg/core';
import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import RevealBox$1 from '../RevealBox/RevealBox.js';
import StyledLogoWall from './LogoWall.style.js';

const LogoWall = ({
  clients
}) => {
  const [ref, isVisible] = useReveal();
  return /*#__PURE__*/React$1.createElement(StyledLogoWall, {
    ref: ref
  }, /*#__PURE__*/React$1.createElement(RevealBox$1, {
    isVisible: isVisible
  }, clients.map(item => item.logo.length > 0 ? /*#__PURE__*/React$1.createElement("div", {
    className: "logoWall__client",
    key: item.id
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "logoWall__client-inner"
  }, /*#__PURE__*/React$1.createElement(Image, {
    src: item.logo[0].url,
    alt: item.logo.alt
  }))) : null)));
};

LogoWall.propTypes = {
  clients: PropTypes$1.arrayOf(PropTypes$1.shape({
    url: PropTypes$1.string,
    alt: PropTypes$1.string
  })).isRequired
};

export default LogoWall;
